import type { CollectionName, ContentStatus, OrderStatus, Status } from '../types'

export const STORE_KEY = 'trevahhh-launch-command-center-v3'
export const BACKUP_KEY = 'trevahhh-auto-backups-v1'
export const REVISION_KEY = 'trevahhh-revisions-v1'
export const CONFIG_KEY = 'trevahhh-cloud-config-v1'
export const META_KEY = 'trevahhh-cloud-meta-v2'
export const LEGACY_META_KEY = 'trevahhh-cloud-meta-v1'

export const ARRAY_COLLECTIONS = ['sprint', 'capacity', 'offers', 'leads', 'orders', 'content', 'decisions', 'daily'] as const
export const SINGLE_COLLECTIONS = ['settings', 'manualChecks'] as const
export const ALL_COLLECTIONS = [...ARRAY_COLLECTIONS, ...SINGLE_COLLECTIONS] as readonly CollectionName[]

export const STATUS_LIST: Status[] = ['Not Contacted', 'Attempted', 'Connected', 'Demo Scheduled', 'Quoted', 'Negotiating', 'Won', 'Lost', 'Nurture']
export const ORDER_STATES: OrderStatus[] = ['Inquiry', 'Quoted', 'Deposit Paid', 'In Production', 'Proof Approval', 'Ready', 'Delivered', 'Complete', 'Cancelled', 'Refunded']
export const CONTENT_STATES: ContentStatus[] = ['Idea', 'Planned', 'Filming', 'Editing', 'Scheduled', 'Published', 'Killed']

export const APP_VERSION = '1.1.0'
